import { render } from "./HomeDesktop.vue?vue&type=template&id=35d81345"
import script from "./HomeDesktop.vue?vue&type=script&lang=js"
export * from "./HomeDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__